<template>
  <div class="pick-list" @click="select">
    <div class="row">
      <div class="col-xs-12 pick-item-title">
        <h4>
          <span class="label pick-item-label">
            {{config.title}}
          </span>
        </h4>
        <div v-if="fieldNote.show" :class="fieldNote.class">
          <i>
            {{ fieldNote.tooltip }}
          </i>
        </div>
      </div>
      <div class="col-xs-12 pick-list-container" :class="layout">
        <div v-for="(item, i) in configValues"
             :key="`pick-item-${item.code}-${i}`">
          <c-checkbox
            v-if="checkBoxValues"
            :value="checkBoxValues[item.code]"
            type="reaInfADI"
            size="sm"
            side="left"
            :block="item.img == null"
            @input="toggle(item.code, $event)">
            <div v-if="item.img">
              <tooltip :text="item.value" :enterable="false">
                <img :src="require(`@/${item.img}`)"
                           class="img-responsive">
              </tooltip>
            </div>
            <div v-else class="pick-checkbox-text">
              <strong>{{item.value}}</strong>
            </div>
          </c-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import assert from '@/sui/tools/assert'
import checkbox from '@/sui/components/checkbox'
import noteImpl from '@/sui/components/sheet/add/impl/notes'

import clone from 'clone'

export default {
  name: 'pick-list',
  props: {
    selected: Boolean,

    value: {
      type: Object
    },

    note: {
      type: Object
    },

    parameters: {
      required: true,
      type: Object
    }
  },

  data: function () {
    return {}
  },

  computed: {
    config: function () {
      return this.parameters.config.config
    },

    displayOptions: function () {
      return this.config.display
    },

    layout: function () {
      const d = this.displayOptions
      if (d == null || d.layout == null) {
        return `columns-xs-1`
      }

      assert.isObject(d.layout)
      let result = ''
      for (let key in d.layout) {
        assert(
          () => {
            if (['xs', 'sm', 'md', 'lg'].indexOf(key) === -1) {
              return `Invalid key ${key}`
            }
            return null
          }
        )
        const value = d.layout[key]
        assert.isNumber(value)
        assert(value >= 1 && value <= 4)

        result = `${result} columns-${key}-${value}`
      }

      return result
    },

    configValues: function () {
      const values = this.config.values

      const imgDirectory = this.displayOptions == null ? null : this.displayOptions.imgDirectory
      const result = []

      for (let i = 0; i < values.length; i++) {
        const v = values[i]
        const item = {
          code: v.code,
          value: v.value
        }

        if (imgDirectory != null) {
          item.img = `${imgDirectory}/${v.code}.jpg`
        }
        result.push(item)
      }
      return result
    },

    fieldNote: function () {
      return noteImpl.getNote(this.note)
    },

    checkBoxValues: function () {
      const configValues = this.configValues
      const existingValues = this.value

      const checkBoxValues = {}
      for (let i = 0; i < configValues.length; i++) {
        const code = configValues[i].code
        let v = false

        if (existingValues) {
          v = existingValues[code]
          assert.notNull(v, `No value for code ${code}`)
        }

        checkBoxValues[code] = v
      }
      return checkBoxValues
    }
  },

  methods: {
    toggle: function (item, value) {
      if (this.checkBoxValues[item] !== value) {
        const newValue = clone(this.checkBoxValues)
        newValue[item] = value
        this.$emit('commit', newValue)
      }
    },

    select: function () {
      if (!this.selected) {
        this.$emit('select')
      }
    }
  },

  components: {
    'c-checkbox': checkbox
  }
}

</script>
<style scoped lang="less">
@import '~variables';
@import '~modules';

.pick-list {
  .pick-item-title {
    .pick-item-label {
      &:extend(.label-dark-primary);
      display: block;
      text-align: left;
    }
  }

  .item {
    padding-bottom: 8px;
  }

  .img-responsive {
    border-radius: 1rem;
    max-width: 100%;
  }

  .pick-checkbox-text {
    font-size: 110%;
  }

  .pick-list-container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    text-align: center;

    & > div {
      padding: 0.5rem;
    }
  }
}

.columns() {
  1: 100%;
  2: 50%;
  3: 33.3%;
  4: 25%;
}

.pick-list {

  each(.columns(),
  .(@value, @key) {

    .columns-xs-@{key} {
      & > div {
        flex-basis: @value;
      }
    }
  }
  )

  @media (min-width: @screen-sm-min) {
    each(.columns(),
    .(@value, @key) {
      .columns-sm-@{key} {
        & > div {
          flex-basis: @value;
        }
      }
    }
    )
  }

  @media (min-width: @screen-md-min) {
    each(.columns(),
    .(@value, @key) {

      .columns-md-@{key} {
        & > div {
          flex-basis: @value;
        }
      }
    }
    )
  }

  @media (min-width: @screen-lg-min) {
    each(.columns(),
    .(@value, @key) {

      .columns-lg-@{key} {
        & > div {
          flex-basis: @value;
        }
      }
    }
    )
  }
}

</style>
